/**
 * TipButton · iter137
 * Wiederverwendbarer Trigger-Button, der das TipModal öffnet.
 * Props: creator, source, sourceId, variant, size
 */
import { useState } from "react";
import { Heart } from "lucide-react";
import TipModal from "./TipModal";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

export default function TipButton({ creator, source, sourceId, variant = "default", size = "sm", label, dataTestid }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (!creator) return null;
  // Selbst-Tipping ausblenden
  const cid = creator.person_id || creator._id || creator.id;
  if (user && cid && String(user._id) === String(cid)) return null;

  const isChip = variant === "chip";
  const cls = isChip
    ? "inline-flex items-center gap-1.5 rounded-full border border-pink-200 bg-pink-50 text-pink-700 hover:bg-pink-100 transition-colors"
    : "inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] text-white hover:bg-[#222] transition-colors";
  const sizeCls = size === "lg" ? "h-11 px-5 text-sm font-bold" : (isChip ? "h-8 px-3 text-xs font-semibold" : "h-9 px-4 text-xs font-bold");

  return (
    <>
      <button
        data-testid={dataTestid || `tip-btn-${source?.toLowerCase()}-${cid}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!user) { navigate("/login"); return; }
          setOpen(true);
        }}
        className={`${cls} ${sizeCls}`}>
        <Heart size={size === "lg" ? 16 : 12} className={isChip ? "fill-pink-500" : "fill-current"} />
        {label || "Trinkgeld"}
      </button>
      <TipModal open={open} onClose={() => setOpen(false)} creator={creator} source={source} sourceId={sourceId} />
    </>
  );
}
